import { useEffect, useState } from 'react';
import type { MeasureText } from './lib/layout';
import { measureLabel } from './measureLabel';

/** The y-label text measurer, replaced each time the page finishes loading web fonts so earlier widths get measured again. */
export const useLabelMeasure = (): MeasureText => {
  const [measure, setMeasure] = useState<MeasureText>(() => measureLabel);

  useEffect(() => {
    const fonts = typeof document === 'undefined' ? undefined : document.fonts;
    if (!fonts) return;
    const onLoaded = () =>
      setMeasure(() => (text: string) => measureLabel(text));
    fonts.addEventListener('loadingdone', onLoaded);
    return () => fonts.removeEventListener('loadingdone', onLoaded);
  }, []);

  return measure;
};
